<template>
  <div class="sass-partner-card">
    <div class="saas-partner-card__logo">
      <img
        v-if="partner.logo"
        :src="partner.logo.image.src"
        :alt="partner.logo.title"
        :srcset="`${partner.logo.retina_image.src} 2x`"
      />
    </div>

    <div>
      <div class="saas-partner-card__headline">
        <strong>{{ partner.name }}</strong>

        <div class="saas-partner-card__badge">
          <Badge :color="badgeColor" rounded size="large">{{
            partnerType
          }}</Badge>
        </div>
      </div>
    </div>

    <p class="saas-partner-card__description">{{ partner.description }}</p>

    <Button
      tag="a"
      :href="partner.link"
      full-width
      type="secondary"
      target="_blank"
      rel="nofollow noopener noreferrer"
      >Visit website</Button
    >
  </div>
</template>

<script>
export default {
  name: 'PartnerCard',
  props: {
    partner: {
      type: Object,
      required: true,
    },
  },
  computed: {
    badgeColor() {
      switch (this.partner.type) {
        case 'hosting':
          return 'cyan'
        case 'implementation':
          return 'green'
        case 'solution':
          return 'magenta'
      }
      return ''
    },
    partnerType() {
      const name = this.partner.type.split('')
      if (name.length > 0) {
        name[0] = name[0].toUpperCase()
      }
      return name.join('')
    },
  },
}
</script>
